import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const MoneyBill = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 5H4C2.3 5 1 6.3 1 8V16C1 17.7 2.3 19 4 19H20C21.7 19 23 17.7 23 16V8C23 6.3 21.7 5 20 5ZM6 13C5.4 13 5 12.6 5 12C5 11.4 5.4 11 6 11C6.6 11 7 11.4 7 12C7 12.6 6.6 13 6 13ZM14.9 12.6C14.6 14.2 13 15.3 11.4 15C9.8 14.7 8.7 13.1 9 11.5C9.2 10.3 10.2 9.4 11.4 9.1C13 8.8 14.6 9.8 14.9 11.5C15 11.8 15 12.2 14.9 12.6ZM18 13C17.4 13 17 12.6 17 12C17 11.4 17.4 11 18 11C18.6 11 19 11.4 19 12C19 12.6 18.6 13 18 13Z"
      fill="currentColor"
    />
  </svg>
)

export default MoneyBill
